import {API} from './api'
export default function buildUrl(url){
    return API+url
}